import * as React from 'react'

function SvgBi(props) {
	return (
		<svg viewBox="0 0 500 300" width="1em" height="1em" {...props}>
			<defs>
				<use id="bi_svg__f" xlinkHref="#bi_svg__e" x={250} y={106} />
				<g id="bi_svg__e" fill="#1eb53a">
					<g id="bi_svg__d">
						<g id="bi_svg__c">
							<g id="bi_svg__b">
								<path id="bi_svg__a" d="M0-20V0h20" transform="rotate(30 0 -20)" />
								<use xlinkHref="#bi_svg__a" transform="scale(-1 1)" />
							</g>
							<use xlinkHref="#bi_svg__b" transform="rotate(120)" />
							<use xlinkHref="#bi_svg__b" transform="rotate(240)" />
						</g>
						<use xlinkHref="#bi_svg__c" transform="rotate(180)" />
					</g>
					<use xlinkHref="#bi_svg__d" fill="#ce1126" transform="scale(.82)" />
				</g>
			</defs>
			<path d="M0 0h500L0 300h500z" fill="#ce1126" />
			<path d="M0 0v300L500 0v300z" fill="#1eb53a" />
			<path d="M0 0l500 300m0-300L0 300" stroke="#fff" strokeWidth={40} />
			<circle cx={250} cy={150} r={85} fill="#fff" />
			<use xlinkHref="#bi_svg__f" />
			<use xlinkHref="#bi_svg__f" transform="rotate(120 250 150)" />
			<use xlinkHref="#bi_svg__f" transform="rotate(240 250 150)" />
		</svg>
	)
}

export default SvgBi
